
import { useTranslation } from "react-i18next";
import CV from "../../assets/documents/CV-Enderson-Millan-Software-Developer-Full-Stack.pdf"; 
import "./header.css";
import HeaderSocials from "./HeaderSocials";

const Header = () => {
  const { t } = useTranslation();

  return (
    <header>
      <div className="container header__container">
        <h3>{t("header.greeting")}</h3>
        <h1>Enderson Millan</h1>
        <h3 className="text-light">{t("header.title")}</h3>
        <div className="cta">
          <a href={CV} download="CV-Enderson-Millan-Software-Developer-Full-Stack.pdf" className="btn">
            {t("header.cv")}
          </a>
          <a href="#contact" className="btn">
            {t("header.talk")}
          </a>
        </div>
        <HeaderSocials />
      </div>
    </header>
  );
};

export default Header;
